import { campaignAssistantRedirect, landingPageCreatorRedirect, blogIdeasGeneratorMicroappRedirect, marketingEmailCreatorRedirect } from '../intents/intentLinks';
import { getQueryParams } from '../routing/getQueryParams';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
export const getCampaignAssistantRedirect = state => {
  return campaignAssistantRedirect(getPortalId(state), getHublet(state), getQueryParams());
};
export const getBlogIdeasGeneratorRedirect = state => {
  return blogIdeasGeneratorMicroappRedirect(getPortalId(state), getHublet(state), getQueryParams());
};
export const getLandingPageCreatorRedirect = state => {
  return landingPageCreatorRedirect(getPortalId(state), getHublet(state), getQueryParams());
};
export const getMarketingEmailCreatorRedirect = state => {
  return marketingEmailCreatorRedirect(getPortalId(state), getHublet(state), getQueryParams());
};